<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody:{"parkCode":"2KKN6111"},
            responseCode: 	{"data":{"ruleList":[{"code":"52","maxValue":100,"name":"测试","type":0,"unit":1,"value":100}],"total":13},"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取积分兑换规则",
                t_url: this.commonUrls.test+"getExchangeRule",
                p_url: this.commonUrls.prod+"getExchangeRule",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'int', info4: '规则总数' },
                        { info1: 'ruleList', info2: '是', info3: 'JSONArray', info4: '积分兑换规则列表' },
                        ]
                },{
                    titleName: 'ruleList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'code', info2: '是', info3: 'String', info4: '规则唯一编号' },
                        { info1: 'name', info2: '是', info3: 'String', info4: '规则名称' },
                        { info1: 'type', info2: '是', info3: 'int', info4: '0兑换金额' },
                        { info1: 'unit', info2: '是', info3: 'int', info4: '兑换单位（多少积分）' },
                        { info1: 'value', info2: '是', info3: 'int', info4: '兑换值（金额单位分，停车时间单位分钟）' },
                        { info1: 'maxValue', info2: '是', info3: 'int', info4: '最大兑换积分' }
                        ]
                }
                ]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/score/getExchangeRule.vue